
import Component from "vue-class-component";
import Vue from "vue";
import {Prop} from "vue-property-decorator";
import {BModal} from "bootstrap-vue";
import {
  DocumentAttributesClient, ManualInvalidationReason,
  InvalidationReasonModel
} from "@/api-client";
import LabelOptional from "@/features/shared/components/LabelOptional.vue";
import {authService} from "@/AuthService";

@Component({
    components: {
        LabelOptional,
    }
})
export default class ConfirmWithInvalidationReasonAndCommentModal extends Vue {
  @Prop({required: true})
  title! : string;

  @Prop({required: true})
  actionButtonText! : string;

  @Prop({required: true})
  confirm!: (comment : string, reason : ManualInvalidationReason) => Promise<undefined>;

  invalidationReasonOptions: InvalidationReasonModel[] = [];
  
  selectedReason: ManualInvalidationReason | null = null;
  
  comment = "";

  $refs!: {bmodal: BModal}
  
  async created() {
      if (!authService.isLoggedIn)
          return;
      
      (await new DocumentAttributesClient().invalidationReasons()).forEach(x => this.invalidationReasonOptions.push(x));
  }

  cancel() {
    this.$refs.bmodal.hide();
    this.comment = "";
    this.selectedReason = null;
  }

  async confirmInner() {
    this.$refs.bmodal.hide(); // NOTE: This has to be before awaiting callback.
    await this.confirm(this.comment, this.selectedReason!)
  }

  public async show() {
    this.$refs.bmodal.show();
    await this.getInvalidationReasonOptionsIfNecessary();
  }
  
  get isButtonDisabled(): boolean {
    return this.selectedReason === null;
  }

  async getInvalidationReasonOptionsIfNecessary(){
    if (this.invalidationReasonOptions.length === 0) {
      (await new DocumentAttributesClient().invalidationReasons()).forEach(x => this.invalidationReasonOptions.push(x));
    }
  }
}
